import {
    SET_FORMATION,
    SET_TYPES_FORMATION,
    SET_LISTE_FORMATION,
} from './mutations-type'

var _ = require('underscore');

// initial state
const state = {
    formation: null,
    textes: null,
    types_formation: [],
    liste_formation: [],
}

// mutations
const mutations = {
    [SET_FORMATION](state, message) {
        state.formation = message;
    },
    [SET_TYPES_FORMATION](state, message) {
        state.types_formation = message;
    },
    [SET_LISTE_FORMATION](state, message) {
        state.liste_formation = message;
    },
}

const actions = {
    setFormation({commit}, msg) {
        commit(SET_FORMATION, msg)
    },
    setTypesFormation({commit}, msg) {
        commit(SET_TYPES_FORMATION, msg)
    },
    setListeFormation({commit}, msg) {
        commit(SET_LISTE_FORMATION, msg)
    },
}

const getters = {
    getFormation: state => {
        return state.formation;
    },
    getTypesFormation: state => {
        return state.types_formation;
    },
    getListeFormation: state => {
        return state.liste_formation;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/store-formation.js